import { render, staticRenderFns } from "./authData.vue?vue&type=template&id=61aec98f&scoped=true"
import script from "./authData.vue?vue&type=script&lang=js"
export * from "./authData.vue?vue&type=script&lang=js"
import style0 from "./authData.vue?vue&type=style&index=0&id=61aec98f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aec98f",
  null
  
)

export default component.exports